/**
 * @generated SignedSource<<17700e807fba8f7ae085df27950524c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getClickCardDataPropertyDatasetsByIdsQuery$variables = {
  property_id: number;
};
export type getClickCardDataPropertyDatasetsByIdsQuery$data = {
  readonly sys_properties_datasets: ReadonlyArray<{
    readonly dataset: {
      readonly dataset_description: string;
    };
  }>;
};
export type getClickCardDataPropertyDatasetsByIdsQuery = {
  response: getClickCardDataPropertyDatasetsByIdsQuery$data;
  variables: getClickCardDataPropertyDatasetsByIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "is_active",
            "value": {
              "_eq": true
            }
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "property_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_properties_datasets",
    "kind": "LinkedField",
    "name": "sys_properties_datasets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_datasets",
        "kind": "LinkedField",
        "name": "dataset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataset_description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getClickCardDataPropertyDatasetsByIdsQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getClickCardDataPropertyDatasetsByIdsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "81de25391fd1958608822171496975e0",
    "id": null,
    "metadata": {},
    "name": "getClickCardDataPropertyDatasetsByIdsQuery",
    "operationKind": "query",
    "text": "query getClickCardDataPropertyDatasetsByIdsQuery(\n  $property_id: Int!\n) {\n  sys_properties_datasets(where: {property_id: {_eq: $property_id}, is_active: {_eq: true}}) {\n    dataset {\n      dataset_description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ac6edb152b7e88725066700da379c0d";

export default node;
